import React, { useState } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import PatientDatas from "src/modules/medcard/patient-datas";
import PreSurgeryTab from "../pages/PreSurgeryTab";
import PostSurgeryTab from "../pages/PostSurgeryTab";
import PatientInfoTab from "../pages/PatientInfoTab";
import { useTranslate } from "src/locales";

const SurgeryPreparationPage = () => {
    const [activeTab, setActiveTab] = useState(0);
    const [isFormEditable, setIsFormEditable] = useState(false); 

    const { t } = useTranslate();

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setActiveTab(newValue);
    };

    const handleAdd = () => {
        setIsFormEditable(true);
    };

    const handleDelete = () => {
        // Form sıfırlanır, kapatılır, başa dönülür
        setIsFormEditable(false);
        setActiveTab(0);
    };

    const handleSave = () => {
       
       //console.log("Form Verisi:", formData);
        alert("Form verisi console'da gösterildi!");
    };

    return (
        <Box>
            <PatientDatas isCreateMedCard />
            <Tabs value={activeTab} onChange={handleTabChange} sx={{ mb: 2 }}>
                <Tab label={t("surgery-pre-post-preparation.pre-surgery-tab")} />
                <Tab label={t("surgery-pre-post-preparation.post-surgery-tab")} />
                <Tab label={t("surgery-pre-post-preparation.patient-info-tab")} />
            </Tabs>
            {activeTab === 0 && <PreSurgeryTab isEditable={isFormEditable} />}
            {activeTab === 1 && <PostSurgeryTab isEditable={isFormEditable} />}
            {activeTab === 2 && <PatientInfoTab isEditable={isFormEditable} />}
        </Box>
    );
};

export default SurgeryPreparationPage;
